var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linkedin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,25.85c-3.27,0-6.54,0-9.81,0a3,3,0,0,1-3.1-3.15V3.23a3,3,0,0,1,3-3.07q9.92,0,19.82,0a3,3,0,0,1,2.93,2.95q0,9.89,0,19.77a3,3,0,0,1-3,3c-3.28,0-6.57,0-9.85,0Zm8.44-4.34a.31.31,0,0,0,.05-.13c0-2.63,0-5.26-.05-7.88a3.62,3.62,0,0,0-1.85-3.13,4.37,4.37,0,0,0-5.25.79c-.1.12-.21.23-.42.45V10.19H10.62V21.51H14v-.92c0-1.88,0-3.77.07-5.66A2,2,0,0,1,16.16,13,1.91,1.91,0,0,1,18,15c0,2,0,4.08,0,6.12a2.85,2.85,0,0,0,0,.4ZM4.84,10.17V21.51h3.4V10.17ZM4.51,6.54a2,2,0,0,0,2,2.09,2.06,2.06,0,0,0,2-2.07A2,2,0,0,0,6.47,4.49,2,2,0,0,0,4.51,6.54Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.afc72ef65c71d5d033b65005046dc9ea.svg";
export { ForwardRef as ReactComponent };